/*
Copyright 2023 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

export const mediaToXdmKeys = {
  "a.media.show": "show",
  "a.media.season": "season",
  "a.media.episode": "episode",
  "a.media.asset": "assetID",
  "a.media.genre": "genre",
  "a.media.airDate": "firstAirDate",
  "a.media.digitalDate": "firstDigitalDate",
  "a.media.rating": "rating",
  "a.media.originator": "originator",
  "a.media.network": "network",
  "a.media.type": "showType",
  "a.media.adLoad": "adLoad",
  "a.media.pass.mvpd": "mvpd",
  "a.media.pass.auth": "authorized",
  "a.media.dayPart": "dayPart",
  "a.media.feed": "feed",
  "a.media.format": "streamFormat",
  "a.media.artist": "artist",
  "a.media.album": "album",
  "a.media.label": "label",
  "a.media.author": "author",
  "a.media.station": "station",
  "a.media.publisher": "publisher",
  "media.resumed": "hasResume"
};
export const adsToXdmKeys = {
  "a.media.ad.advertiser": "advertiser",
  "a.media.ad.campaign": "campaignID",
  "a.media.ad.creative": "creativeID",
  "a.media.ad.placement": "placementID",
  "a.media.ad.site": "siteID",
  "a.media.ad.creativeURL": "creativeURL"
};